// Legal Services Page
import image from 'images/illustrations/legal.png';

export const legal = {
  intro: {
    heading: 'Make legal headaches go away',
    copy: [
      'Overwhelmed with paperwork and jargon? Our network of attorneys will explain things and point you in the right direction.',
    ],
  },

  cta: {
    number: '8007467047',
    copy: 'to find the right lawyer',
  },

  extraInfo: [
    {
      heading: 'Browse online resources',
      copy: [
        'Find useful legal info, digital forms, and legal templates for things like bankruptcy, citizenship, real estate, and small business management.',
      ],
      buttons:[
        {
          button: 'primary',
          label: 'Search Now',
          link: 'https://clc.clientsecured.com/clc/index.cfm?aft=7B13B1A8',
        },
      ],
    },
  ],

  iconList: [
    {
      icon: 'message',
      title: 'Get a law consultation at no cost to you',
      copy: [
        'Get one hour of consulting for family law matters or 30 minutes of consultation for other legal advice.',
      ],
    },
    {
      icon: 'discount',
      title: 'Get discounts on further legal assistance',
      copy: [
        'Get 25% off attorney fees for most cases and 35% off for family law matters.',
      ],
    },
    {
      icon: 'star',
      title: 'Get access to legal documents & resources',
      copy: [
        'Access a portal with legal forms, templates, articles, definitions, and court rulings.',
      ],
    },
  ],

  helpList: [
    'Divorce',
    'Contracts',
    'Power of attorney',
    'Wills',
    'Civil judgement',
    'Real estate',
    'Custody&nbsp;issues',
    'Bankruptcy',
    'Traffic violations',
    'Criminal matters',
    'Adoption',
    'Car accidents',
  ],
  image,
};



// WEBPACK FOOTER //
// ./client/models/services/legal.js